'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  list: {
    flex: 'initial'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-layout/lib/templates/Drawer/DrawerItemsList/styles.js
// module id = 625
// module chunks = 61549186969478 79611799117203